import { groupBy } from 'lodash';
import { UUID } from 'v2/core/entities/uuid';

interface organiseColumnsParams<T> {
  rows: string[][];
  groupKey: keyof T;
  options: readonly T[];
  columnsLength: number;
}

export function organiseColumns<T extends { id: string }>({
  rows,
  groupKey,
  options,
  columnsLength,
}: organiseColumnsParams<T>) {
  const optionsByGroup = groupBy(options, groupKey);
  const columnOptionLimitByRowID: Record<string, number[]> = {};
  const optionIndexByOptionID: Record<string, number> = {};
  const groupsByRowColumn: string[][][] = [];
  const optionIDByRowColumnOptionIndex: UUID[][][] = [];

  rows.forEach((row, rowIndex) => {
    columnOptionLimitByRowID[rowIndex] = new Array(columnsLength).fill(0);
    const groupIDsByColumn: string[][] = [];

    row.forEach((groupID) => {
      if (!optionsByGroup[groupID]) {
        return;
      }

      const groupOptionsCount = optionsByGroup[groupID].length;

      const columnIndex =
        columnOptionLimitByRowID[rowIndex][0] <=
        columnOptionLimitByRowID[rowIndex][1]
          ? 0
          : columnsLength - 1;

      optionsByGroup[groupID].forEach((option, optionIndex) => {
        optionIndexByOptionID[option.id] =
          optionIndex + columnOptionLimitByRowID[rowIndex][columnIndex];

        if (!optionIDByRowColumnOptionIndex[rowIndex]) {
          optionIDByRowColumnOptionIndex[rowIndex] = [];
        }
        if (!optionIDByRowColumnOptionIndex[rowIndex][columnIndex]) {
          optionIDByRowColumnOptionIndex[rowIndex][columnIndex] = [];
        }
        optionIDByRowColumnOptionIndex[rowIndex][columnIndex].push(option.id);
      });

      columnOptionLimitByRowID[rowIndex][columnIndex] += groupOptionsCount;

      if (!groupIDsByColumn[columnIndex]) {
        groupIDsByColumn[columnIndex] = [];
      }

      groupIDsByColumn[columnIndex].push(groupID);
    });

    if (groupIDsByColumn.length) {
      groupsByRowColumn.push(groupIDsByColumn);
    }
  });

  return {
    optionsByGroup,
    columnOptionLimitByRowID,
    optionIndexByOptionID,
    groupsByRowColumn,
    optionIDByRowColumnOptionIndex,
  };
}
